<!-- footer.component.html -->
<footer class="text-white text-center py-4" style="bottom: 0px;">
  <p>&copy; {{ footerText }}</p>
  <div>
    <a href="#" class="text-white mx-2"><i class="fab fa-facebook-f"></i></a>
    <a href="#" class="text-white mx-2"><i class="fab fa-twitter"></i></a>
    <a href="#" class="text-white mx-2"><i class="fab fa-instagram"></i></a>
  </div>
</footer>
